import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "paypal-tip-content rel" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]

import { t } from '@/plugins/i18n'

import { isEN, isKO, isJA } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible'],
  setup(__props, { emit: emits }) {

const props = __props


const cancel = () => {
  emits('update:visible', false)
}
const jump = () => {
  const enUrl = 'https://www.paypal.com/us/cshelp/article/how-do-i-cancel-a-scheduled-paypal-credit-payment-help240'
  const jaUrl = 'https://www.paypal.com/jp/cshelp/article/%E8%87%AA%E5%8B%95%E6%94%AF%E6%89%95%E3%81%84%E3%81%A8%E3%81%AF%E4%BD%95%E3%81%A7%E3%81%99%E3%81%8B-%E3%81%BE%E3%81%9F%E3%80%81%E6%9B%B4%E6%96%B0%E3%81%BE%E3%81%9F%E3%81%AF%E3%82%AD%E3%83%A3%E3%83%B3%E3%82%BB%E3%83%AB%E3%81%99%E3%82%8B%E6%96%B9%E6%B3%95%E3%82%92%E6%95%99%E3%81%88%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84%E3%80%82-help240'
  window.open(isJA() ? jaUrl : enUrl)
  emits('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    footer: false,
    "custom-class": "paypal-tip-dialog",
    "show-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "iconfont icon-guanbi2 abs",
          onClick: cancel
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('请取消PayPal自动续费')), 1),
        _createElementVNode("div", {
          class: "text",
          innerHTML: _unref(t)('已设定Paypal的自动支付，请解除以前的Paypal自动支付。如果未解除，将自动进行费用充值。请注意，对于错误费用的退款，您将需要支付退款费用。')
        }, null, 8, _hoisted_3),
        _createElementVNode("div", {
          class: "btn",
          onClick: jump,
          target: "_blank"
        }, _toDisplayString(_unref(t)('我知道了')), 1)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})